import React from 'react';
import constants from 'modules/app/constants/materialize';
import classNames from 'classnames';

class Icon extends React.Component {
    render() {
        let classes = {
            'material-icons': true
        };
        constants.PLACEMENTS.forEach(p => {
            classes[p] = this.props[p];
        });

        constants.ICON_SIZES.forEach(s => {
            classes[s] = this.props[s];
        });
        return <i className={classNames(classes, this.props.className)}>{this.props.children}</i>;
    }
}

Icon.propTypes = {
    tiny: React.PropTypes.bool,
    small: React.PropTypes.bool,
    medium: React.PropTypes.bool,
    large: React.PropTypes.bool,
    className: React.PropTypes.string,
    children: React.PropTypes.node
};

export default Icon;